import { render, staticRenderFns } from "./updated.vue?vue&type=template&id=4e0db2e2&scoped=true&lang=pug&"
import script from "./updated.vue?vue&type=script&lang=js&"
export * from "./updated.vue?vue&type=script&lang=js&"
import style0 from "./updated.vue?vue&type=style&index=0&id=4e0db2e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0db2e2",
  null
  
)

export default component.exports